module.exports = __webpack_public_path__ + "9047a712b122a42b2c4ea95e622ea75f.svg";